import { PCCase, ReferenceObject, FormFactor, CaseSize } from '../types';

export const pcCases: PCCase[] = [];

export const referenceObjects: ReferenceObject[] = [
  {
    id: 'soda-can',
    name: 'Standard Soda Can',
    dimensions: { height: 122, width: 66, depth: 66 },
    imageUrl: '/references/soda-can.png',
    description: '12 oz (355ml) standard beverage can',
  },
  {
    id: 'iphone-15',
    name: 'iPhone 15 Pro',
    dimensions: { height: 147, width: 71, depth: 8 },
    imageUrl: '/references/iphone.png',
    description: 'Apple iPhone 15 Pro smartphone',
  },
  {
    id: 'credit-card',
    name: 'Credit Card',
    dimensions: { height: 54, width: 86, depth: 1 },
    imageUrl: '/references/credit-card.png',
    description: 'Standard ISO credit card size',
  },
  {
    id: 'keyboard-fullsize',
    name: 'Full-size Keyboard',
    dimensions: { height: 35, width: 440, depth: 140 },
    imageUrl: '/references/keyboard.png',
    description: 'Standard 104-key full-size keyboard',
  },
  {
    id: 'ps5',
    name: 'PlayStation 5',
    dimensions: { height: 390, width: 104, depth: 260 },
    imageUrl: '/references/ps5.png',
    description: 'Sony PlayStation 5 console (disc edition)',
  },
  {
    id: 'xbox-series-x',
    name: 'Xbox Series X',
    dimensions: { height: 301, width: 151, depth: 151 },
    imageUrl: '/references/xbox.png',
    description: 'Microsoft Xbox Series X console',
  },
];

export const sizeCategories: CaseSize[] = ['Full-Tower', 'Mid-Tower', 'Mini-Tower', 'SFF', 'HTPC'];
export const formFactors = ['E-ATX', 'ATX', 'Micro-ATX', 'Mini-ITX', 'Mini-DTX'] as const;
export const sidePanelTypes = ['Tempered Glass', 'Mesh', 'Steel', 'Acrylic'];

// Helper to get case by ID
export const getCaseById = (id: string): PCCase | undefined => {
  return pcCases.find(c => c.id === id);
};

// Helper to filter cases
export const filterCases = (filters: Partial<{
  sizeCategories: string[];
  formFactors: string[];
  manufacturers: string[];
  minGpuLength: number;
  minCoolerHeight: number;
  sidePanelTypes: string[];
  searchQuery: string;
}>): PCCase[] => {
  return pcCases.filter(c => {
    if (filters.sizeCategories?.length && !filters.sizeCategories.includes(c.sizeCategory)) return false;
    if (filters.formFactors?.length && !filters.formFactors.some(f => c.formFactorSupport.includes(f as FormFactor))) return false;
    if (filters.manufacturers?.length && !filters.manufacturers.includes(c.manufacturer)) return false;
    if (filters.minGpuLength !== undefined && c.maxGpuLength < filters.minGpuLength) return false;
    if (filters.minCoolerHeight !== undefined && c.maxCpuCoolerHeight < filters.minCoolerHeight) return false;
    if (filters.sidePanelTypes?.length && !c.sidePanel.some(p => filters.sidePanelTypes!.includes(p))) return false;
    if (filters.searchQuery) {
      const query = filters.searchQuery.toLowerCase();
      const matchesName = c.name.toLowerCase().includes(query);
      const matchesManufacturer = c.manufacturer.toLowerCase().includes(query);
      const matchesDescription = c.description.toLowerCase().includes(query);
      if (!matchesName && !matchesManufacturer && !matchesDescription) return false;
    }
    return true;
  });
};
